module.exports = __webpack_public_path__ + "static/img/105.bfde2fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/105.jpg
// module id = 9tqJ
// module chunks = 2